import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { getErrorFormat } from 'core/utils/errors';
import { updateAssetToPayload } from '../mappers';
import { AssetUpdateModel } from '../models';

interface Props {
  host: string;
  token: string;
  assetId: string;
  data: AssetUpdateModel;
}

const getUrl = ({ host, assetId }: { host: string; assetId: string }) => {
  return `${host}/assets/${assetId}`;
};

export const UpdateAsset = async ({ host, token, assetId, data }: Props): Promise<void> => {
  try {
    const url = getUrl({ host, assetId });

    const mappedData = updateAssetToPayload({ assetId, data });

    const options: AxiosRequestConfig = {
      url,
      method: 'PATCH',
      timeout: 10000,
      headers: {
        Accept: 'application/json, text/plain, */*',
        'Content-Type': 'application/json;charset=UTF-8',
        Authorization: token,
        'Accept-version': '1',
      },
      data: { data: mappedData },
    };

    (await axios(options)) as AxiosResponse<void>;
  } catch (error) {
    throw getErrorFormat(error);
  }
};
